/**
 * 2分探索で近い値のインデックスを求める
 * @param {array<number>} sourceList 近い値を探す元の配列
 * @param {number} target 配列から探す値
 * @returns {number} 近い値の元配列のインデックス。検索元の配列が空であれば-1を返す
 */
export const binarySearch = (sourceList, target) => {
  let resultIndex = -1;
  let left = 0;
  let right = sourceList.length - 1;
  let mid;

  if (!sourceList || !sourceList.length) {
    return resultIndex;
  }

  while (left <= right) {
    mid = Math.floor((left + right) / 2);
    if (sourceList[mid] === target) {
      // 検索値と一致した場合は、そのインデックスを返す
      return mid;
    } else if (sourceList[mid] < target) {
      left = mid + 1;
    } else {
      right = mid - 1;
    }
  }

  if (left > sourceList.length - 1) {
    // 元配列の最大値より大きい場合は、最後のインデックスを返す
    return sourceList.length - 1;
  }

  if (target - sourceList[right] < sourceList[left] - target) {
    resultIndex = right;
  } else {
    resultIndex = left;
  }
  return resultIndex;
};

export default {
  binarySearch
};